import dayjs from 'dayjs'
import { makeDateSeries } from '@local_modules/generic/dates/make-date-series/index.js'
import { activateOptionSelector } from '../../../../modules/option-selector/index.js'

export function showSelectors (changeAction, context) {
  console.log('showSelectors', context)

  const optionSelectorShow = [
    'filterDates',
    'optionsJournals'
  ]

  const dateSeriesStart = context.browserAppAccount?.data?.firstLedgerDate || dayjs().subtract(48, 'months').format('YYYY-MM-DD')
  const dateseries = makeDateSeries(dateSeriesStart)

  const currenciesForAccount = context.currenciesForAccount

  const selectorOptions = {
    containerId: 'optionSelector',
    show: optionSelectorShow,
    hide: ['currencies', 'dates'],
    default: 'organisations',
    onChange: changeAction,
    dateseries,
    customSettings: {
      organisations: mapOrganisations(context),
      orgOptions: {
        allowConso: false,
        allowMultiple: false
        // defaultIndex: 0
      },
      currencies: currenciesForAccount
    },
    filterDates: {
      defaults: {
        records: {
          from: dayjs().add(-1, 'day').format('YYYY-MM-DD'),
          to: dayjs().format('YYYY-MM-DD')
        }
      }
    },
    optionsJournals: {
      defaults: {
        grouping: 'byAccount'
      }
    }
  }
  console.log(selectorOptions)

  const optionSelectorParams = activateOptionSelector(selectorOptions)
  console.log('optionSelectorParams', optionSelectorParams)
  return optionSelectorParams
}

function mapOrganisations (context) {
  if (context.specificOrgId) return forNoAccount(context)

  return context.entities
}

/** Allowing the page to be loaded for a specific entity, without a specific account */
function forNoAccount (context) {
  return [{
    _id: context.specificOrgId,
    name: context.specificOrgId
  }]
}
